"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intBinOpToInt = void 0;
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var Term_1 = require("../../../Term/index.js");
var type_system_1 = require("../../../type_system/index.js");
var papp_1 = require("../../papp.js");
function intBinOpToInt(builtin) {
    var op = new Term_1.Term((0, type_system_1.fn)([type_system_1.int, type_system_1.int], type_system_1.int), function (_dbn) { return builtin; });
    return (0, obj_utils_1.defineReadOnlyProperty)(op, "$", function (fstIn) {
        var oneIn = (0, papp_1.papp)(op, fstIn);
        return (0, obj_utils_1.defineReadOnlyProperty)(oneIn, "$", function (sndIn) {
            return (0, papp_1.papp)(oneIn, sndIn);
        });
    });
}
exports.intBinOpToInt = intBinOpToInt;
